<div class="container-404">
  <div class="error-template">
    <h3>Oops!</h3>
    <h2>Page non trouvée</h2>
    <div class="error-details">Désolé, cette page n'existe pas!</div>
    <div class="error-actions">
      <a routerLink="/"> Retour à la page d'accueil </a>
    </div>
  </div>
</div>
